import { render, staticRenderFns } from "./TheGroupModal.vue?vue&type=template&id=56a4d809"
import script from "./TheGroupModal.vue?vue&type=script&lang=js"
export * from "./TheGroupModal.vue?vue&type=script&lang=js"
import style0 from "./TheGroupModal.vue?vue&type=style&index=0&id=56a4d809&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports